module.exports = __webpack_public_path__ + "static/media/logo.8ac83418.svg";